/*
 * Usage:
 *
 * <my-component v-loadcover="fetchInProgress"></my-component>
 *
 */
export default {
  bind(el, { value }) {
    updateLoadCoverCssClass({ el, value })
  },
  update(el, { value }) {
    updateLoadCoverCssClass({ el, value })
  },
}

const CLASS = 'loader-cover'

function updateLoadCoverCssClass({ el, value }) {
  if (value) {
    el.classList.add(CLASS)
  } else {
    el.classList.remove(CLASS)
  }
}
